module.exports = __webpack_public_path__ + "img/yz_8@2x.46d86fd4.png";